import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    barContainer: {
      width: "100%",
    },
    progressRoot: {
      height: 10,
      borderRadius: 5,
      border: "1px solid black",
      backgroundColor: "white",
    },
    progressCompleteBar1: {
      backgroundColor: "grey",
    },
    progressRunningBar1: {},
  })
);

const useAppLinearProgress = (isComplete: boolean) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({
    appLinearProg: {
      root: styles.progressRoot,
      bar1Determinate: isComplete ? styles.progressCompleteBar1 : styles.progressRunningBar1,
    },
  }), [styles, isComplete]);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export {useAppLinearProgress as default};
